/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sessions_Tab_TripsInputs */

const en_ui_sessions_tab_trips = /** @type {(inputs: Ui_Sessions_Tab_TripsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trips`)
};

const de_ui_sessions_tab_trips = /** @type {(inputs: Ui_Sessions_Tab_TripsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touren`)
};

/**
* | output |
* | --- |
* | "Trips" |
*
* @param {Ui_Sessions_Tab_TripsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sessions_tab_trips = /** @type {((inputs?: Ui_Sessions_Tab_TripsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sessions_Tab_TripsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sessions_tab_trips(inputs)
	return de_ui_sessions_tab_trips(inputs)
});